import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_2835_11551)'>
      <g clipPath='url(#clip1_2835_11551)'>
        <path
          d='M15 8.38477V19.6976C15.0001 19.8209 15.0306 19.9424 15.0888 20.0511C15.147 20.1598 15.2311 20.2526 15.3337 20.321L16.365 21.0082C16.465 21.0749 16.5796 21.1166 16.6991 21.1297C16.8186 21.1428 16.9395 21.127 17.0517 21.0837C17.1638 21.0403 17.2638 20.9706 17.3434 20.8804C17.4229 20.7903 17.4797 20.6824 17.5087 20.5657L18.75 15.8848'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.75 19.6346C3.75003 19.7775 3.79085 19.9173 3.86765 20.0377C3.94446 20.1582 4.05405 20.2542 4.18354 20.3144C4.31304 20.3747 4.45705 20.3967 4.59864 20.3779C4.74023 20.3592 4.87351 20.3003 4.98281 20.2084C9.89531 16.0871 15 15.8846 15 15.8846H18.75C19.7446 15.8846 20.6984 15.4895 21.4017 14.7863C22.1049 14.083 22.5 13.1292 22.5 12.1346C22.5 11.1401 22.1049 10.1862 21.4017 9.48298C20.6984 8.77972 19.7446 8.38463 18.75 8.38463H15C15 8.38463 9.89531 8.18213 4.98281 4.06182C4.87357 3.96992 4.74038 3.91111 4.59887 3.89229C4.45737 3.87347 4.31343 3.89543 4.18397 3.95558C4.05451 4.01573 3.9449 4.11158 3.86803 4.23186C3.79116 4.35215 3.75021 4.49188 3.75 4.63463V19.6346Z'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_2835_11551'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(0 0.884766)'
        />
      </clipPath>
      <clipPath id='clip1_2835_11551'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(0 0.884766)'
        />
      </clipPath>
    </defs>
  </svg>,
  'Reporting'
)
